<template>
  <div class="row">
    <div class="col">
      <form @submit.prevent="search"
            autocomplete="no"
            @keydown="clearError($event)"
      >
        <div class="row mb-2">
          <div class="col">
            <h4 class="search-heading">Vendor Search</h4>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Vendor Name</label>
              <input v-model="searchData.name"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Account Number</label>
              <input v-model="searchData.accNumber"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="accNumber" />
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>ZIP Code</label>
              <input v-model="searchData.addressZip"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="addressZip" />
          </div>
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Network</label>
              <simple-select v-model="searchData.networks"
                             :options="networkOptions"
                             placeholder="Select Network"
                             autocomplete="no"
              />
            </div>
            <error-field :errors="errors" field="addressState" />
          </div>
        </div>

        <div class="row mt-3 mb-3">
          <div class="col">
            <button class="btn btn-warning ld-ext-right w-full"
                    :disabled="buttonDisabled || !formInvalid"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  name: 'VendorSearch',
  components: {
    ErrorField,
  },
  data: () => ({
    buttonDisabled: false,
    errors: new Errors(),
    networkOptions: [{ id: '0', name: 'Bill.com' }, { id: '1', name: 'Large Biller' }],
    searchData: {
      accNumber: '',
      addressZip: '',
      name: '',
      networks: '0',
    },
    searchResults: [],
  }),
  computed: {
    formInvalid() {
      return !!this.searchData.name.length;
    },
  },
  methods: {
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    search() {
      this.buttonDisabled = true;
      const requestData = {
        ...this.searchData,
      };
      if (this.searchData.networks === null) {
        delete requestData.networks;
      }
      axios
        .post(`bill/search`, requestData)
        .then(res => {
          this.searchResults = res.data.data;
          if (this.searchResults.length) {
            this.$emit('searchCompleted', this.searchResults);
          } else {
            toastr.info('No results found in selected network.');
          }
        })
        .catch(err => this.errors.record(err.response.data.error))
        .finally(() => {
          this.buttonDisabled = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.search-heading {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/companies/mod24settings/VendorSearch.vue